import { Component, OnInit,ChangeDetectorRef,EventEmitter, Output} from '@angular/core';
import {QueryBuilderComponent} from "angular2-query-builder";

@Component({
  selector: 'app-ct-query-builder',
  templateUrl: './ctquerybuilder.component.html',
  styleUrls: ['ctquerybuilder.scss']
})
export class CTQueryBuilderComponent extends QueryBuilderComponent implements OnInit {
  public apiFilter = '';
  @Output() fileChange = new EventEmitter<{event: any, rule: any}>();
  @Output() exportExcel = new EventEmitter();
  @Output() onfilter = new EventEmitter();
  @Output() onSearch = new EventEmitter();
  @Output() resetPage = new EventEmitter();

  constructor(private ref:ChangeDetectorRef) {
    super(ref); 
  }

  ngOnInit() {
    //should be override according  operators to https://github.com/castle-it/dynamic-linq-query-builder
    //todo: check how to work with for operator did not exist or not the same string equivalent to dynamic-linq-query-builder
    this.defaultOperatorMap['number'] =  ["equal","not_equal","greater","less","in","not_in"];
    this.defaultOperatorMap['boolean'] = ["equal"];
    this.defaultOperatorMap['category'] = ["equal","not_equal","contains","not_contains","contain_value","not_contain_value","greater","less","in","not_in"]; //todo: check how to work with not_contain_value in backend
    this.defaultOperatorMap['date'] = ["equal","not equal","greater","greater_or_equal","less","less_or_equal"];
    this.defaultOperatorMap['inputBtn'] =  ["equal","not_equal","contains","not_contains","contain_value","not_contain_value","greater","less","in","not_in"];
    this.defaultOperatorMap['string'] =   ["equal","not_equal","contains","not_contains","contain_value","not_contain_value","greater","less","in","not_in"];
    this.defaultOperatorMap['time'] = ["equal","not_equal","greater","greater_or_equal ","less","less_or_equal"];
  }

  onFileChange(event: any,rule:any) {
    this.fileChange.emit({event:event,rule:rule});
  }

  exportToExcel(rule){
    this.exportExcel.emit(rule);
  }

  fetchMore(e){
     this.onfilter.emit(e);
  }
  
  execKeypress(event:any,field:string) {
    var temp = {"field":field,"term":event.term}
    this.onSearch.emit(temp);
  }

  change(){
    console.log("change");
    this.resetPage.emit();
  }
}